import React, { useContext, useState } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import { Box, Button } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';
import useFootprintContext from '../context/useFootprintContext';

function Table() {
  const { footprints, handleViewEngagement, handleExportFootprintReport } =
    useContext(useFootprintContext);

  const [sortModel, setSortModel] = useState([
    {
      field: 'id',
      sort: 'desc',
    },
  ]);

  const columns = [
    {
      field: 'year',
      headerName: 'Year',
      width: 200,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'date_engaged',
      headerName: 'Date Engaged',
      width: 200,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'date_scheduled',
      headerName: 'Date Scheduled',
      width: 200,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'name',
      headerName: 'Admin/AS/DAM',
      width: 200,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'collector',
      headerName: 'Collector',
      width: 200,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'code',
      headerName: 'Code',
      width: 200,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'customer_name',
      headerName: 'Cutomer Name',
      width: 600,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'moe',
      headerName: 'Mode of Engagement',
      width: 300,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'status',
      headerName: 'Status',
      width: 200,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'client_commitment',
      headerName: 'Client Commitment',
      width: 200,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'amount_collected',
      headerName: 'Amount Collected',
      width: 200,
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) =>
        Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(row.amount_collected) ?? '',
    },
    {
      field: 'collection_type',
      headerName: 'Type of Collection',
      width: 200,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'engagement_proof',
      headerName: 'Proof of Engagement',
      width: 200,
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) =>
        row?.engagement_proof?.length > 0 ? (
          <Button onClick={() => handleViewEngagement(row?.engagement_proof)} variant='text'>
            View Engagement
          </Button>
        ) : (
          ''
        ),
    },
    {
      field: 'remarks',
      headerName: 'Remarks',
      width: 200,
      headerClassName: 'super-app-theme--header',
    },
  ];

  return (
    <Grid container spacing={2}>
      <Grid xs={12} sm={12} md={12}>
        <Box>
          <Grid md={12}>
            <Button
              variant='contained'
              color='success'
              sx={{
                marginTop: '10px',
                padding: 1,
                float: 'right',
                marginLeft: '10px',
              }}
              onClick={handleExportFootprintReport}
            >
              Export Footprint
            </Button>
          </Grid>
        </Box>
      </Grid>
      <Grid xs={12} sm={12} md={12}>
        <Box
          className='table-container'
          sx={{
            height: '800px',
            '& .super-app-theme--header': {
              fontWeight: 'bold',
              backgroundColor: '#6B8D3E',
              color: '#fff',
            },
            '& .even-row': {
              backgroundColor: '#c3d1b1',
            },

            '& .odd-row': {
              backgroundColor: '#f0f3eb',
            },
          }}
        >
          <DataGridPro
            loading={footprints?.loading}
            rows={footprints?.table}
            columns={columns}
            sortModel={sortModel}
            initialState={{
              ...footprints?.table.initialState,
              pagination: { paginationModel: { pageSize: 50 } },
            }}
            pageSizeOptions={[25, 50, 75, 100]}
            pagination
            onSortModelChange={(model) => setSortModel(model)}
            getRowClassName={(params) => {
              return params.indexRelativeToCurrentPage % 2 === 0 ? 'even-row' : 'odd-row';
            }}
          />
        </Box>
      </Grid>
    </Grid>
  );
}

export default Table;
